import { render, staticRenderFns } from "./DemoDropdown.vue?vue&type=template&id=6817afd6&"
import script from "./DemoDropdown.vue?vue&type=script&lang=js&"
export * from "./DemoDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports